export const messages = {
  en: {
    aShop: {
      queryCondition: 'Query Condition',
      shopName: 'Shop Name',
      selectStatus: 'Select Status',
      approved: 'Approved',
      rejected: 'Rejected',
      selectMerchant: 'Select Merchant',
      query: 'Query',
      shopInfo: 'Shop Information',
      shopLogo: 'Shop Logo',
      shopType: 'Shop Type',
      merchantName: 'Merchant Name',
      merchantAddress: 'Merchant Address',
      contactNumber: 'Return Phone',
      returnPhone: 'Return Phone',
      shopStatus: 'Shop Status',
      createTime: 'Create Time',
      operation: 'Operation',
      withdraw: 'Withdraw',
      detail: 'Detail'
    }
  },
  zh: {
    aShop: {
      queryCondition: '查询条件',
      shopName: '店铺名称',
      selectStatus: '请选择状态',
      approved: '审核通过',
      rejected: '审核不通过',
      selectMerchant: '请选择商家',
      query: '查询',
      shopInfo: '店铺信息',
      shopLogo: '店铺logo',
      shopType: '店铺类型',
      merchantName: '商家名称',
      merchantAddress: '商家地址',
      contactNumber: '退货电话',
      returnPhone: '退货电话',
      shopStatus: '店铺状态',
      createTime: '创建时间',
      operation: '操作',
      withdraw: '撤回',
      detail: '详情'
    }
  }
}